import React from 'react'
import { Button, ButtonVariant } from '../../../common/Button'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { IconChoices } from '../../../common/Icon'
import { openUrl } from '../../../../helpers/url'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
import { stringToSlug } from '../../../../helpers/slug'
import { ISocietyWebsiteModel } from '../../../../interfaces/models/societies-websites.interfaces'

interface SocietyWebsiteBottomBarProps {
  website: ISocietyWebsiteModel
  isValid?: boolean
  loading?: boolean
}

export const SocietyWebsiteBottomBar = ({
  website,
  isValid,
  loading,
}: SocietyWebsiteBottomBarProps): React.ReactNode => {
  const { society } = useCurrentSociety()
  const { translate } = useAppTranslation()

  const websiteUrl = `https://${stringToSlug(
    `${website.slug}-${society?.addressCity}`
  )}.boappa.se/`

  const openWebsite = (): void => {
    openUrl(websiteUrl)
  }

  return (
    <div className="mt-6 mb-4 space-y-6 md:mt-10">
      <div className="border-t" />
      <div className="flex justify-between">
        <Button
          variant={ButtonVariant.DEFAULT}
          label={translate('societyWebsiteView.visitWebsite')}
          icon={IconChoices.WEBSITE}
          onClick={openWebsite}
        />
        <Button
          variant={ButtonVariant.PRIMARY}
          label={translate('common.actions.save')}
          disabled={!isValid}
          loading={loading}
          type="submit"
        />
      </div>
    </div>
  )
}
